import { Hide, SimpleGrid } from '@chakra-ui/react';
import { getSellPath } from '@habity/services';
import {
  FooterSection,
  FooterSectionLink,
  FooterSectionTitle,
} from './FooterSection';

export function FooterContent() {
  return (
    <SimpleGrid
      columns={{ mobile: 1, desktop: 4 }}
      rowGap={{ mobile: 10, desktop: 0 }}
    >
      <SellSection />
      <BuySection />
      <ErikOlssonSection />
      <SupportSection />
    </SimpleGrid>
  );
}

function SellSection() {
  return (
    <FooterSection>
      <FooterSectionTitle title="Sälja" />
      <FooterSectionLink
        href={getSellPath(undefined, 'meeting')}
        label="Sälj bostad"
      />
      <Hide below="desktop">
        <FooterSectionLink
          href={getSellPath(undefined, 'valuation')}
          label="Värdera bostad"
        />
      </Hide>
      <Hide below="desktop">
        <FooterSectionLink href="/brokers" label="Våra mäklare" />
      </Hide>
      <FooterSectionLink
        href="https://minasidor.erikolsson.se"
        label="Mina sidor"
      />
    </FooterSection>
  );
}

function BuySection() {
  return (
    <FooterSection>
      <FooterSectionTitle title="Köpa" />
      <Hide below="desktop">
        <FooterSectionLink href="/homes" label="Våra bostäder" />
      </Hide>
      <FooterSectionLink href="/buy" label="Skapa bostadsbevakning" />
      <FooterSectionLink href="/p/nyproduktion" label="Nyproduktion" />
      <FooterSectionLink
        href="/homes?categories=commercial"
        label="Kommersiellt"
      />
      <FooterSectionLink
        href="https://www.erikolsson.se/utland/"
        label="Utland"
      />
    </FooterSection>
  );
}

function ErikOlssonSection() {
  return (
    <FooterSection>
      <FooterSectionTitle title="Erik Olsson" />
      <FooterSectionLink
        href="https://erikolsson.teamtailor.com/"
        label="Karriär"
      />
      <FooterSectionLink href="/p/om-oss" label="Om oss" />
      <FooterSectionLink href="/bostadsguiden" label="Bostadsguiden" />
      <FooterSectionLink
        href="/marknadskommentar"
        label="Marknadskommentaren"
      />
    </FooterSection>
  );
}

function SupportSection() {
  return (
    <FooterSection>
      <FooterSectionTitle title="Support" />
      <FooterSectionLink href="/auth/login" label="Skapa inlogg" />
      <FooterSectionLink href="/p/kontakta-oss" label="Kontakta oss" />
      <FooterSectionLink href="/p/faq" label="Vanliga frågor & Svar" />
      <FooterSectionLink
        href="https://bolaneansokan.soderbergpartners.se/erik-olsson/"
        label="Bolån"
      />
    </FooterSection>
  );
}
